import React, { Component } from 'react'
import { connect } from 'react-redux'

// used e.g. import questions help video
class HelpVideoModal extends Component {
  render() {
    const {
      videoUrl,
      autoplay = true,
      muted = false,
      loop = false,
      closeHelpVideoModal,
    } = this.props

    return (
      <div className='helpVideoModalContainer'>
        <div className='helpVideoModal'>
          { /* eslint-disable-next-line jsx-a11y/media-has-caption */ }
          <video
            className='helpVideoModal-video'
            controls
            autoPlay={autoplay}
            muted={muted}
            loop={loop}
            preload='metadata'
          >
            <source src={videoUrl} type='video/webm' />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className='helpVideoModalContainer--BG' onClick={() => { closeHelpVideoModal() }} />
      </div>
    )
  }
}

export default connect(
  () => ({}),
  { },
)(HelpVideoModal)
